<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
        <h2>Add Country</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <form #f="ngForm" name="form" novalidate> 
        <div class="dialog-content-block p-3">
               <div class="gap-5 w-100 mt-4">
                
                  <div class="form-group"> 
                    <div class="cabinet-dropdown stores"> 
                        <h6 class="text-start text-dark">Region</h6>
                        <div class="w-100">
                            <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isRegionDropDown.set(!isRegionDropDown())">
                                <span>{{ selectedRegion.value }}</span>
                                <img src="../../../assets/images/dropdown.png" [class]="isRegionDropDown() ? 'drop-down-btn-icon--rotate' : ''" alt="arrow">
                            </span>
                            <ul class="dropdown-menu dropdown-content" [class]="isRegionDropDown() ? 'd-block' : ''">
                              <li *ngFor="let region of regions" class="dropdown-item"  (click)="onRegionTypeChange(region)">{{ region.value }}</li>
                            </ul>
                        </div>
                    </div>
                  </div>
                
                
                    <div class="form-group mt-4">
                        <h6 class="text-start text-dark">Country</h6>
                        <input type="text" name="product_code" [(ngModel)]="nameTxt" value="">
                        <div class="form-error-msg"></div>
                    </div>  
                  
            </div>
        </div>
        <!-- <div class="form-error-msg">
            <p *ngIf="serverErrorMessage !== ''">{{ serverErrorMessage }}</p>
        </div> -->
        <div class="dialog-footer">
            <button type="button" (click)="onClose()">Cancel</button>
            <button class="primary-btn addproduct" type="submit" (click)="onAdd()">Add</button>
        </div>
    </form> 
</div>
